import React from 'react'
import MuiGrid, { GridProps } from '@mui/material/Grid'

function Grid(props: GridProps) {
  return <MuiGrid {...props} />
}

export { Grid }
